import React, { useEffect } from "react";
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { MenuBar } from "./menu-bar";
import Placeholder from '@tiptap/extension-placeholder'
import '../../../styles/component/tiptap-editor.scss'

type TiptapEditorProps = {
    value?: string;
    onChange?: (value: string) => void;
};

const TiptapEditor = ({value,onChange}:TiptapEditorProps) => {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Placeholder.configure({
            placeholder: 'Start typing here...'
        })],
        content: value || '',
        onUpdate: ({ editor }) => {
            onChange?.(editor.getHTML());
        },
    });

    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value || '');
        }
    }, [editor, value]);

    return (
        <div className="editor-container">
            {editor && <MenuBar editor={editor}/>}
            <EditorContent editor={editor} className={'editor-box'}/>
        </div>
    );
};

export default TiptapEditor;
